import {
    FETCH_ONLINE_USER_TOKENS,
    FETCH_ONLINE_USERS,
    FETCH_ONLINE_USER_COUNT_STATS,
} from '../actions/onlineUser';


export const initialState = {
    isFetching: true,
    data: null
};

export const onlineUsers = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_ONLINE_USERS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_ONLINE_USERS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const onlineUserTokens = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_ONLINE_USER_TOKENS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_ONLINE_USER_TOKENS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}


export const onlineUserCountStats = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_ONLINE_USER_COUNT_STATS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_ONLINE_USER_COUNT_STATS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/redux/reducers/onlineUser.js